var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loadingCounter)?_c('div',{staticClass:"loading-box"},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"loading",attrs:{"type":"ios-loading","size":"18"}}),(_vm.loadingText)?_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }